import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import '../../assets/styles/pages/market/market-page.scss';
import TabHeader from '../../components/TabHeader/TabHeader';
import { CUSTOM_STYLES } from '@/constants/app';
import Watchlist from '../../components/Watchlist/Watchlist';
import MarketInfo from '../../components/Market/MarketInfo';
import News from '@/components/News/News';
import {Instrument} from '@/configurations/components-configs/components.config'
import WatchlistMinimize from '../../components/Watchlist/WatchlistMinimize';
import { openColDefChooseDialog } from '@/actions/app'
import InstrumentLightweightCharts from '@/components/@charting/InstrumentLightweightCharts';
import { getElementWidthHeightById } from '@/helpers/global';
import { appEnvironment } from '@/configurations/app-configs/app.setting.config';
import InstrumentProfile from '@/components/Instrument/InstrumentProfile';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { WatchlistHelper } from '@/helpers/functions/watchlist.helper';
import {Converter , utilsFunction} from '@/helpers/functions'
import { userActions } from '@/actions/user';
// import BlockControl from '@components/BlockControl/BlockControl'
import DetailCenter from '../../components/DetailCenter/DetailCenter';
import { history } from '@/configurations';
import { stockActions } from "@/actions/trading/stock.action";
import { PATH } from '@/constants/paths';
import MarketBottomTab from '@/companys/fubon/components/MarketDetailBottomTab/MarketDetailBottomTab'
import { checkAuth as checkAuthServices } from '@/services/auth-services';

const CHART_TAB = 'chart_tab';
const PROFILE_TAB = 'profile_tab';
const MARKET_TAB = 'market_markets';
const WATCHLIST_TAB = 'market_watchlists'
let isOpenDeleteWatchlistCol = false

class Market extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenChart: iTradeEnv?.pages?.market?.init?.isOpenChart ?? false,
      isOpenNews: true,
      isOpenInstrumentInfo: true,
      Tab: [{ id: '1', title: 'market_watchlists', children:  [
        {
          id: 1, title: 'common_position', value:'position'
        },
        {
          id: 2, title: 'market_all', value:''
        },
        {
          id: 3, title: 'market_hkex', value:'HKEX'
        },
        {
          id: 4, title: 'market_usex', value:'USEX'
        },
        {
          id: 5, title: 'market_stock_connect',value:'CN'
        },
      ], isActive: false },
      {
        id: '2', title: 'market_markets', isActive: false,
        children: [
          {
            id: 1, title: 'market_hkex', value: 'HK'
          },
          // {
          //   id: 2, title: 'market_usex', value: 'US'
          // },
          {
            id: 3, title: 'market_stock_connect', value: 'CN'
          },
        ]
      },],
      chartStyles: null,
      tab: 'position',
      tabs: [
        { id: 1, title: 'chart' },
        { id: 2, title: 'common_profile' }
      ],
      // selectedTab: CHART_TAB,
      selectedTab: WATCHLIST_TAB, 
      currentTab :{ id: '1', title: 'watchlist_title', children:  [
        {
          id: 1, title: 'common_position', value:'position'
        },
        {
          id: 2, title: 'market_all', value:''
        },
        {
          id: 3, title: 'market_hkex', value:'HKEX'
        },
        {
          id: 4, title: 'market_usex', value:'USEX'
        },
        {
          id: 5, title: 'market_stock_connect',value:'CN'
        }
      ], isActive: false },
      subTab:{value :"position"},
      enableDeleteIcon:false,
      isWatchList : true,
      stockDetail : false,
      preSubTab :{
        id: 1, title: 'common_position', value:'position'
      },
      isrefresh:false,
      quoteData:""
    }
    props.innerRef(this);
    this.event = ['mousemove', 'keyup']
  }

  render() {
    const { Tab, selectedTab ,subTab ,  isWatchList ,stockDetail  , isOpenChart , isOpenInstrumentInfo , currentTab , quoteData} = this.state
    return (
      <div className={classnames('market-container', !stockDetail ? 'market-container-open' : 'detail-container detail-container-open')} ref={e => this.marketContainerRef = e}>
        {!stockDetail ? (
          <section className={classnames('left', `market-content-${iTradeEnv.company}`)}>
            <section id='chart-wl-container' className='upper' style={{ height: '100%' }}>
              <section id='watchlist-section' className='watchlist'>
                <TabHeader
                  tabs={Tab}
                  refresh
                  onRefresh={() => this.refresh(isWatchList, subTab.value)}
                  onChangeMainTab={this.handleChangeMainTab}
                  AAStockDisclaimer={false}
                  handleChangeSubTab={this.handleChangeSubTab}
                  onClickColumnSetting={() => this.handleClickColumnSetting(currentTab, subTab)}
                  stockDetail={stockDetail}
                />
                {selectedTab === WATCHLIST_TAB && (
                  <Watchlist
                    onRef={c => (this.Watchlist = c)}
                    innRef={c => {
                      this.Watchlistfiter = c
                    }}
                    onClickSymbol={(marketID, StockID) => this.handleClickSymbol(marketID, StockID)}
                    marketCode={subTab.value}
                    profile
                  />
                )}
                {selectedTab === MARKET_TAB && <MarketInfo onRef={e => (this.MarketInfoRef = e)} subTab={subTab.value} />}
              </section>
            </section>
          </section>
        ) : (
          <>
            <section className={classnames('left', `market-content-${iTradeEnv.company}`)} style={{ width: '70%' }}>
              <section id='chart-wl-container' className='upper' style={{ height: '65%' }}>
                <section id='watchlist-section' className='watchlist'>
                  <WatchlistMinimize
                    innerRef={c => {
                      this.WatchlistMinimize = c
                    }}
                    onWatchlistMinimizeRendered={this.onWatchlistMinimizeRendered}
                    onClose={this.handleCloseInstrument}
                  />
                </section>
                <section id='chart-section' className={classnames('chart', isOpenChart && 'chart-open')}>
                  <DetailCenter quoteData={quoteData}></DetailCenter>
                </section>
              </section>
              <section className={classnames('news', 'news-open')}>
                {/* <News /> */}
                <MarketBottomTab quoteData={quoteData} />
              </section>
            </section>
            <section
              className={classnames('instrument-infor', `instrument-infor-${iTradeEnv.company}`, isOpenInstrumentInfo && 'instrument-infor-open')}
              style={{ width: '23%', minWidth: '420px' }}
            >
              {isOpenInstrumentInfo && (
                <Instrument
                  p_Identifier={this.props.p_Identifier}
                  pieChart
                  alert
                  watchlist
                  index
                  bidask
                  profile
                  tradeInformation
                  placeOrder={true}
                  chart={!isOpenChart}
                  toggleChart={this.handleToggleChart}
                  refreshhistory={this.refreshhistory}
                  onRef={c => (this.instrument = c)}
                />
              )}
            </section>
          </>
        )}
      </div>
    )
  }

  handleToggleChart = () => {
    this.setState({ isOpenChart: !this.state.isOpenChart })
  }


  handleChangeMainTab = (tab) => {
    switch (tab.title) {
      case 'market_markets': {
        this.setState({ selectedTab: MARKET_TAB , currentTab : tab, isWatchList :false , subTab :{value:"HK"}})
        break;
      }
      case 'market_watchlists': {
        this.setState({ selectedTab: WATCHLIST_TAB, currentTab : tab ,  isWatchList :true, subTab:{value:'position'} ,preSubTab :{
          id: 1, title: 'common_position', value:'position'
        },})
        break;
      }
      default:
        break;
    }
  }


  handleChangeSubTab = (subTab , currentMainTab) => {
    const { preSubTab } = this.state
    this.setState({
      subTab,
      preSubTab : subTab
    }, () => {
      if(JSON.stringify(preSubTab) === JSON.stringify(subTab)) return
        if(subTab.value === 'position'){
          this.Watchlist.getPostion()
        }else if(subTab.value === ''){
          this.Watchlistfiter.getPostion()
        }else{
          if(this.Watchlistfiter){
            this.Watchlistfiter.getWatchLists(subTab.value)  
          }
        }
        
    })
    if (subTab && currentMainTab.id === "1") {
      // const { watchlist } = this.props
      let enableDeleteIcon = true
      if(subTab.title==='common_position'){
        enableDeleteIcon = false
      }else if (isOpenDeleteWatchlistCol) {
        this.handleOpenDelete()
      }
      // this.setState({  enableDeleteIcon: enableDeleteIcon }, () => {
      //   this.initHeader()
      // })
    }
    this.props.history.push(PATH.MARKET_DATA)
  }

  refresh=(isWatchList,marketCode)=>{
    if(this.state.isrefresh) return
    this.setState({isrefresh: true})
    if(isWatchList){
      if(marketCode === '' ){
        this.Watchlistfiter.getPostion(()=>{
          this.setState({isrefresh: false})
        })
      }else if( marketCode === 'position'){
        this.Watchlist.getPostion(()=>{
          this.setState({isrefresh: false})
        })
      }else{
        this.Watchlistfiter.getWatchLists(marketCode,()=>{
          this.setState({isrefresh: false})
        })
      }
    }else{
      this.MarketInfoRef.refresh(marketCode,()=>{
        this.setState({isrefresh: false})
      })
    }
  }

  refreshhistory=()=>{
    if(this.WatchlistMinimize.state.selectedTab === 1){
      return
    }
    this.WatchlistMinimize.getQuoteHistory()
  }

  handleClickSymbol=(marketID,StockID)=>{
    let  currentSelect = null
    switch(this.state.subTab.title){
      case 'market_all':
        currentSelect = {"id": 1,"title": "market_all","value": ""}
        break;
      case 'market_hkex':
        currentSelect = {"id": 2,"title": "market_hkex","value": "HKEX"}
        break
      case 'market_usex':
        currentSelect = {"id": 3,"title": "market_usex","value": "USEX"}
        break
      case 'market_stock_connect':
        currentSelect = {"id": 4,"title": "market_stock_connect","value": "CN"}
        break
    }
    this.props.history.push(PATH.MARKET_DATA,{marketID:marketID,StockID:StockID ,search:'marketinfo',chart:true, currentTab:[],subTab:[],history:PATH.MARKET_DATA,currentSelect})
    this.setState({stockDetail:true})
  }

  handleCloseInstrument=()=>{
    const { location } = this.props.history
    this.props.history.push(location.state.history,{...location.state})
    this.setState({stockDetail:false , subTab:{value :"position"},preSubTab :{
      id: 1, title: 'common_position', value:'position'
    },})
    if(location.state.history===PATH.MARKET_DATA){
      if(location.state){
        const { history } = location.state
        if(history === PATH.MARKET_DATA){
          if(this.state.Tab){
            for(let i=0;i<this.state.Tab.length;i++){
              if(this.state.Tab[i].id === location.state.currentTab.id){
                this.state.Tab[i].isActive = true
                for(let j=0;j<this.state.Tab[i].children.length;j++){
                  if(this.state.Tab[i].children[j].id === location.state.subTab.id){
                    this.state.Tab[i].children[j].isActive=true
                  }
                }
              }
            }
          }
          this.setState({currentTab:location.state.currentTab,subTab:location.state.subTab},()=>{
            // this.tabheader.handleChangeMainTab(location.state.currentTab)
            this.handleChangeSubTab(location.state.subTab,location.state.currentTab)
          })
        }
      }
    }
  }

  handleOpenDelete = () => {
    isOpenDeleteWatchlistCol = !isOpenDeleteWatchlistCol
    if(this.state.subTab.id !=1){
      this.Watchlistfiter.toggleDeleteColumn(isOpenDeleteWatchlistCol)
    }
  }

  // initHeader = (isTriggerChangeTab = false) => {
  //   const { watchlist } = this.props
  //   const { currentTab, subTab, enableDeleteIcon } = this.state
  //   const { custom } = watchlist
  //   const watchlistOptions = { position: true, addIcon: true, removeIcon: enableDeleteIcon }
  //   const watchlistFunctions = { handleOpenDelete: this.handleOpenDelete }
  //   const watchlistChildren = WatchlistHelper.getTabHeader(custom, null, watchlistOptions, watchlistFunctions, '', subTab.id)
  //   const tabs = [
  //     { id: '1', title: 'watchlist_title', children: watchlistChildren, isActive: currentTab.title === 'watchlist_title' },
  //     {
  //       id: '2', title: 'common_market', isActive: false,
  //       children: [
  //         {
  //           id: 1, title: 'market_hkex', value: 'HK'
  //         },
  //         {
  //           id: 2, title: 'market_usex', value: 'US'
  //         },
  //       ]
  //     },
  //   ]
  //   this.setState({ Tab: tabs }, () => {
  //     // this.Watchlist.getPostion()
  //     // setTimeout(() => {
  //     //   const currentActiveTab = this.tabHeaderRef.getCurrentTab()
  //     //   isTriggerChangeTab && this.handleChangeTab(currentActiveTab)
  //     // }, 150)
  //   })
  // }

  onWatchlistMinimizeRendered = (e) => {
    const pDivWH = getElementWidthHeightById("chart-wl-container");
    let chartWH = {
      width: pDivWH.width - e.width - 15
    }
    this.setState({
      chartStyles: chartWH
    })
  }
  
  handleClickColumnSetting = (currentTab,marketCode) => {
    if(currentTab.id==='1'){
      openColDefChooseDialog(this.state.columnDefs, res => {
      this.renderFieldAction(res)
    })
    }
    else{
      if(marketCode.value ==='position'){
        openColDefChooseDialog(this.Watchlist.state?.columnDefs, res => {
        this.renderFieldAction(res,true)
        })
      }else{
        openColDefChooseDialog(this.Watchlistfiter.state?.columnDefs, res => {
          this.renderFieldAction(res,false ,true)
        })
      }
      
    }
    
  }

  renderFieldAction = (fields,isPosition = false , isWatchList = false) => {
    if(isPosition){
      this.Watchlist.setState({ columnDefs: fields })
      this.Watchlist.tableRef.renderColumnDefs(fields)
    }else if(isWatchList){
      this.Watchlistfiter.setState({ columnDefs: fields })
      this.Watchlistfiter.tableRef.renderColumnDefs(fields)
    }
  }

  // getInstrumentWatchlist=()=>{
  //   const { id } = this.props.userInfo
  //   if (id) {
  //     const params = {
  //       uuid: id,
  //       template: 'watchlist2',
  //       language :Converter.mappingWinVestLanguage(this.props.language.lang),
  //       category: 'C'
  //     }
  //     this.props.getInstrumentWatchlistAction(params, res => {
  //       this.setState({custom : res.result},()=>{
  //         this.initHeader()
  //       })
  //     })
  //   }
  // }

  handleEvenet = utilsFunction.throttle(() => checkAuthServices({}), 10000)

  UNSAFE_componentWillMount() {
    const { location } = this.props.history
    if(location.state){
      const { search } = location.state
      if(search === 'marketinfo'){
        this.props.setStock({ stockCode: utilsFunction.instrumentIDZeroPadding(location.state.StockID), marketID: location.state.marketID }, () => {
          this.setState({stockDetail:true})
        })
      }
    }
  }

  componentDidMount() {
    this.event.forEach(key => this.marketContainerRef.addEventListener(key, this.handleEvenet))

    
    // this.initMarketTab(this.props.markets, this.props.watchlist);
    // this.initHeader()
    // this.initHeader()
    // const { location } = this.props.history
    // if(location.state){
    //   const { search } = location.state
    //   if(search === 'marketinfo'){
    //     this.props.setStock({ stockCode: utilsFunction.instrumentIDZeroPadding(location.state.StockID), marketID: location.state.marketID }, () => {
    //       this.setState({stockDetail:true})
    //     })
    //   }
    // }
    // const search = location.search.replace('?','')
  }

  componentDidUpdate(preProps) {
    const { userInfo ,watchlist } = this.props
    if (this.props.mdsToken && this.props.mdsToken !== preProps.mdsToken || this.props.mdsAccountType !== preProps.mdsAccountType) {
      // this.initMarketTab(this.props.markets, this.props.watchlist);
    }
    if (this.instrument && this.instrument !== preProps.instrument){
      if(this.state.quoteData === this.instrument.state.quoteData) return
      this.setState({quoteData:this.instrument.state.quoteData})
    }
    // if(preProps.watchlist.custom != watchlist.custom){
    //   this.initHeader()
    // }
    // if(preProps.userInfo != userInfo && userInfo){
    //   this.getInstrumentWatchlist()
    // }
  }

  
  componentWillUnmount() {
    this.event.forEach(key => this.marketContainerRef.removeEventListener(key, this.handleEvenet))
    this.setState = () => {
      return
    }
  }
  // componentWillReceiveProps(nProps) {
  //   if (JSON.stringify(nProps.markets) !== JSON.stringify(this.props.markets) ||
  //     JSON.stringify(nProps.watchlist) !== JSON.stringify(this.props.watchlist)) {
  //     this.initMarketTab(nProps.markets, nProps.watchlist)
  //   }
  // }
}

Market.defaultProps = {
  p_Identifier: appEnvironment.custom_ctr_configs.marketCtrl,
  innerRef: () => { },
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    mdsAccountType: state.trade.mdsAccountType,
    watchlist: state.user.watchlist,
    mdsToken: state.trade.mdsToken,
    userInfo: state.user.userInfo,
  }),
  dispatch => ({
    getInstrumentWatchlistAction:(p,c) =>dispatch(userActions.getInstrumentWatchlistAction(p, c)),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
  })
)(Market)